import React from "react";
import InstagramIcon from "../ressources/instagram-icon.svg";
import StartnextIcon from "../ressources/startnext-icon.png";
import "./Footer.scss";

const FooterItem = ({ icon, iconAlt, link, linkTitle }) => (
  <div className="footer-item">
    <figure className="image is-24x24">
      <img src={icon} alt={iconAlt} />
    </figure>
    <a href={link} target="_blank" rel="noreferrer">
      {linkTitle}
    </a>
  </div>
);

export const Footer = () => {
  const InstagramLink = "https://www.instagram.com/deepquest_the_cardgame/";
  const StartnextLink = "https://www.startnext.com/deepquest";

  return (
    <footer className="footer">
      <div className="columns">
        <div className="column">
          <FooterItem
            icon={InstagramIcon}
            iconAlt="instagram"
            link={InstagramLink}
            linkTitle="deepquest_the_cardgame"
          />
          <FooterItem icon={StartnextIcon} iconAlt="startnext" link={StartnextLink} linkTitle="DEEP QUEST bestellen" />
        </div>
        <div className="column">
          <div className="footer-item">
            <a id="impressum" href="https://bluebird-eg.de/datenschutzerklaerung" target="_blank" rel="noreferrer">
              Datenschutzerklärung
            </a>
          </div>
          <div className="footer-item">
            <a id="impressum" href="https://bluebird-eg.de/impressum" target="_blank" rel="noreferrer">
              Impressum
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
